import "./experience.css"
import exp_logo from "../../../assets/logo.svg"
import React, {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {Link, useNavigate} from "react-router-dom";
import {connect} from "react-redux";
import {setExpInfoData} from "../../../redux/experience_store";
import {setPersonalData} from "../../../redux/personal_store";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import axios from "axios";

function ExperienceInfo({expInfoData, setExpInfoData, appData, account, personalData}) {

    const {t} = useTranslation()
    const navigate = useNavigate()

    let linkTo = '/conditions'
    if (appData.account_type === 'joint') linkTo = '/owner-info'

    const [expInfoDataErrors, setExpInfoDataErrors] = useState({
        stockYear: '',
        stockAverageSize: '',
        stockAverageNumber: '',
        optionYear: '',
        optionAverageSize: '',
        optionAverageNumber: '',
        invest_obj: '',
    });

    useEffect(() => {
        if (((account.accountType === 'marginAcc' && account.selectedOption === 'level1') ||
            (account.accountType === 'marginAcc' && account.selectedOption === 'level0') ||
            (account.selectedOption !== 'level1' && account.selectedOption !== 'level0'))) {
            handleInputChange({target: {name: 'investmentObjective', value: 'D', type: 'radio', checked: true}})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        setExpInfoDataErrors({
            stockYear: '',
            stockAverageSize: '',
            stockAverageNumber: '',
            optionYear: '',
            optionAverageSize: '',
            optionAverageNumber: '',
        });

        let isValid = true;

        if (!expInfoData.stockYear) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                stockYear: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!expInfoData.stockAverageSize) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                stockAverageSize: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!expInfoData.stockAverageNumber) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                stockAverageNumber: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!expInfoData.optionYear) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                optionYear: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!expInfoData.optionAverageSize) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                optionAverageSize: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!expInfoData.optionAverageNumber) {
            setExpInfoDataErrors((prevErrors) => ({
                ...prevErrors,
                optionAverageNumber: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (isValid) {
            setExpInfoData(expInfoData);
            if (!appData.app_id) alert('Missing app id')

            try {
                await updateExpValues()
                navigate(linkTo)
            } catch (error) {
                setExpInfoDataErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    }

    const handleInputChange = (e) => {
        const {name, value, type, checked} = e.target;

        if (type === "checkbox") {
            setExpInfoData({...expInfoData, [name]: checked});
        } else if (type === "radio" && name === "investmentObjective") {
            setExpInfoData({...expInfoData, invest_obj: value});
        } else {
            setExpInfoData({...expInfoData, [name]: value});
        }
    };

    const getExpValues = () => {
        return {
            accountType: account.accountType,
            OptionTradeLevel: account.selectedOption,
            StockYearsExp: expInfoData.stockYear,
            StockAvgSize: expInfoData.stockAverageSize,
            StockAvgTrans: expInfoData.stockAverageNumber,
            OptionYears: expInfoData.optionYear,
            OptionSize: expInfoData.optionAverageSize,
            OptionAvgTrans: expInfoData.optionAverageNumber,
            InvestmentObj: expInfoData.invest_obj,
        }
    };

    const updateExpValues = async () => {
        try {
            const URL = `${process.env.REACT_APP_API_URL}/api/accounts/step4/` + appData.app_id;
            const params = getExpValues();

            const response = await axios.put(URL, params, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });

            if (response.data && response.data.status && ['404', '500'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            throw error;
        }
    };

    return (
        <div className="experience">
            <div className="experience_left_side">
                <img src={exp_logo} alt=""/>
            </div>
            <div className="experience_right_side">
                <Logout/>
                <div>
                    <p className="experience_heading">{t('experience.welcome')} {personalData.firstName} {personalData.lastName}. {t('experience.investment_experience')}</p>
                    <p className="exp_investment_text">{t('experience.previous_investment')} </p>
                    <form onSubmit={handleSubmit}>
                        <div className="exp_stocks">
                            <span className="exp_stocks_text">{t('experience.stocks')}</span>

                            <div className="exp_selects">
                                <Form.Select aria-label="Default select example" className="exp_form"
                                             name="stockYear"
                                             value={expInfoData.stockYear}
                                             onChange={handleInputChange}>
                                    <option value="" selected disabled>{t('experience.year')}</option>
                                    <option value="1-2">1-2</option>
                                    <option value="3-5">3-5</option>
                                    <option value="6-10">6-10</option>
                                    <option value="10+">10+</option>
                                </Form.Select>
                                {expInfoDataErrors.stockYear &&
                                    <p className="exp_info_error">{expInfoDataErrors.stockYear}</p>}
                            </div>
                            <div className="exp_selects">
                                <Form.Select aria-label="Default select example" className="exp_form"
                                             name="stockAverageSize"
                                             value={expInfoData.stockAverageSize}
                                             onChange={handleInputChange}>
                                    <option value="" selected disabled>{t('experience.average_size')}</option>
                                    <option value="100-500">100-500</option>
                                    <option value="501-1000">501-1000</option>
                                    <option value="1001-5000">1001-5000</option>
                                    <option value="5000+">5000+</option>
                                </Form.Select>
                                {expInfoDataErrors.stockAverageSize &&
                                    <p className="exp_info_error">{expInfoDataErrors.stockAverageSize}</p>}
                            </div>

                            <div className="exp_selects">
                                <Form.Select aria-label="Default select example" className="exp_form"
                                             name="stockAverageNumber"
                                             value={expInfoData.stockAverageNumber}
                                             onChange={handleInputChange}>
                                    <option value="" selected disabled>{t('experience.average_number')}</option>
                                    <option value="1-50">1-50</option>
                                    <option value="51-100">51-100</option>
                                    <option value="101-500">101-500</option>
                                    <option value="501+">501+</option>
                                </Form.Select>
                                {expInfoDataErrors.stockAverageNumber &&
                                    <p className="exp_info_error">{expInfoDataErrors.stockAverageNumber}</p>}
                            </div>
                        </div>

                        <div className="exp_options">
                            <span className="exp_options_text">{t('experience.options')}</span>
                            <div className="exp_selects">
                                <Form.Select aria-label="Default select example" className="exp_form"
                                             name="optionYear"
                                             value={expInfoData.optionYear}
                                             onChange={handleInputChange}>
                                    <option value="" selected disabled>{t('experience.year')}</option>
                                    <option value="0">0</option>
                                    <option value="1-2">1-2</option>
                                    <option value="3-5">3-5</option>
                                    <option value="6-10">6-10</option>
                                    <option value="10+">10+</option>
                                </Form.Select>
                                {expInfoDataErrors.optionYear &&
                                    <p className="exp_info_error">{expInfoDataErrors.optionYear}</p>}
                            </div>

                            <div className="exp_selects">
                                <Form.Select aria-label="Default select example" className="exp_form"
                                             name="optionAverageSize"
                                             value={expInfoData.optionAverageSize}
                                             onChange={handleInputChange}>
                                    <option value="" selected disabled>{t('experience.average_size')}</option>
                                    <option value="0">0</option>
                                    <option value="1-10">1-10</option>
                                    <option value="11-20">11-20</option>
                                    <option value="21-100">21-100</option>
                                    <option value="101+">101+</option>
                                </Form.Select>
                                {expInfoDataErrors.optionAverageSize &&
                                    <p className="exp_info_error">{expInfoDataErrors.optionAverageSize}</p>}
                            </div>
                            <div className="exp_selects">
                                <Form.Select aria-label="Default select example" className="exp_form"
                                             name="optionAverageNumber"
                                             value={expInfoData.optionAverageNumber}
                                             onChange={handleInputChange}>
                                    <option value="" selected disabled>{t('experience.average_number')}</option>
                                    <option value="0">0</option>
                                    <option value="1-50">1-50</option>
                                    <option value="51-100">51-100</option>
                                    <option value="101-500">101-500</option>
                                    <option value="501+">501+</option>
                                </Form.Select>
                                {expInfoDataErrors.optionAverageNumber &&
                                    <p className="exp_info_error">{expInfoDataErrors.optionAverageNumber}</p>}
                            </div>
                        </div>
                        <p className="exp_investment_obj">{t('experience.investment_objective')}</p>
                        <p className="exp_investment_obj_text">{t('experience.speculative_activity')}</p>
                        <p className="exp_objs">{t('experience.objective')}</p>
                        <div className="checks">
                            <input
                                type="radio"
                                value="B"
                                name="investmentObjective"
                                checked={expInfoData.invest_obj === 'B'}
                                onChange={handleInputChange}
                                disabled={
                                    (account.accountType === 'marginAcc' && account.selectedOption === 'level1') ||
                                    (account.accountType === 'marginAcc' && account.selectedOption === 'level0') ||
                                    (account.selectedOption !== 'level1' && account.selectedOption !== 'level0')
                                }
                            />
                            <p className="checkbox_text">{t('experience.risk_tolerance')}</p>
                        </div>
                        <div className="checks">
                            <input
                                type="radio"
                                value="C"
                                name="investmentObjective"
                                checked={expInfoData.invest_obj === 'C'}
                                onChange={handleInputChange}
                                disabled={
                                    account.selectedOption !== 'level1' &&
                                    account.selectedOption !== 'level0'
                                }
                            />
                            <p className="checkbox_text">
                                {t('experience.capital_appreciation')}
                            </p>
                        </div>
                        <div className="checks">
                            <input
                                type="radio"
                                value="D"
                                name="investmentObjective"
                                checked={expInfoData.invest_obj === 'D'}
                                onChange={handleInputChange}
                            />
                            <p className="checkbox_text">{t('experience.time_horizon')}</p>
                        </div>

                        <div className="exp_btn">
                            <Link style={{textDecoration: "none"}} to="/account">
                                <button className="exp_back_btn">{t('back_btn')}</button>
                            </Link>
                            <button className="exp_continue_btn" type="submit">{t('next_btn')}</button>
                        </div>
                        <div>
                            {expInfoDataErrors.submitError && (
                                <div style={{color: 'red', textAlign: "center"}}>
                                    {expInfoDataErrors.submitError}
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    expInfoData: state.expInfoData,
    account: state.account,
    appData: state.appData,
    personalData: state.personalData
});

const mapDispatchToProps = {
    setExpInfoData,
    setPersonalData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceInfo);